/**
 * PIFster POM leaderboard interactions.
 *
 * Restores the legacy copy-to-clipboard and join-link behaviors for the
 * leaderboard component.
 */

(function () {
  'use strict';

  function showToast(message: string): void {
    const toast = document.getElementById('pifster-pom-toast');
    if (!toast) {
      return;
    }

    toast.textContent = message;
    toast.hidden = false;
    toast.classList.add('pifster-pom-leaderboard__toast--visible');

    window.setTimeout(() => {
      toast.classList.remove('pifster-pom-leaderboard__toast--visible');
      window.setTimeout(() => {
        toast.hidden = true;
      }, 300);
    }, 2200);
  }

  function copyText(text: string): Promise<void> {
    if (navigator.clipboard && typeof navigator.clipboard.writeText === 'function') {
      return navigator.clipboard.writeText(text);
    }

    const textarea = document.createElement('textarea');
    textarea.value = text;
    textarea.setAttribute('readonly', 'readonly');
    textarea.style.position = 'absolute';
    textarea.style.left = '-9999px';
    document.body.appendChild(textarea);
    textarea.select();

    try {
      document.execCommand('copy');
      document.body.removeChild(textarea);
      return Promise.resolve();
    } catch (error: unknown) {
      document.body.removeChild(textarea);
      return Promise.reject(error);
    }
  }

  function handleCopyButton(button: HTMLElement): void {
    const targetId = button.getAttribute('data-copy-target');
    if (!targetId) {
      return;
    }

    const input = document.getElementById(targetId);
    if (!(input instanceof HTMLInputElement)) {
      return;
    }

    const value = input.value || '';
    if (!value) {
      return;
    }

    void copyText(value)
      .then(() => {
        showToast('Copied!');
      })
      .catch(() => {
        showToast('Copy failed');
      });
  }

  function handleJoinButton(button: HTMLElement): void {
    const token = button.getAttribute('data-ref-token');
    if (!token) {
      return;
    }

    window.location.href = '/join/?ref=' + encodeURIComponent(token);
  }

  document.addEventListener('click', (event: MouseEvent) => {
    const target = event.target;
    if (!(target instanceof Element)) {
      return;
    }

    const copyButton = target.closest('[data-copy-target]') as HTMLElement | null;
    if (copyButton) {
      handleCopyButton(copyButton);
      return;
    }

    const joinButton = target.closest('[data-ref-token]') as HTMLElement | null;
    if (joinButton) {
      handleJoinButton(joinButton);
    }
  });
})();
